export const SET_TRESTORE = 'SET_TRESTORE';
export const SET_TRESET = 'SET_TRESET';
export const SET_TNOWLISTID = 'SET_TNOWLISTID';
export const SET_TNOWLISTDATA = 'SET_TNOWLISTDATA';
export const SET_TDETAILDATA = 'SET_TDETAILDATA';
export const SET_TTICKECTNUM = 'SET_TTICKECTNUM';
export const SET_TTOTALAMOUNT = 'SET_TTOTALAMOUNT';
export const SET_SALEPRICESPREAD = 'SET_SALEPRICESPREAD';
export const SET_SHOWCROSSELL = 'SET_SHOWCROSSELL';
export const SET_TTEMPCALENDARDATA = 'SET_TTEMPCALENDARDATA';
export const SET_TPICKCALENDAR = 'SET_TPICKCALENDAR';
export const SET_TISDETAILLOADING = 'SET_TISDETAILLOADING';
export const SET_TDETAILLOADINGFAIL = 'SET_TDETAILLOADINGFAIL';
export const SET_TISSESSIONLOADING = 'SET_TISSESSIONLOADING';
export const SET_TSESSIONLOADINGFAIL = 'SET_TSESSIONLOADINGFAIL';
export const SET_TCALENDARERRORMSG = 'SET_TCALENDARERRORMSG';
export const SET_TSESSIONERRORMSG = 'SET_TSESSIONERRORMSG';
export const SET_TTICKETERRORMSG = 'SET_TTICKETERRORMSG';
export const SET_TSCROLLTO = 'SET_TSCROLLTO';
export const SET_TSUBMITWATCHER = 'SET_TSUBMITWATCHER';
export const SET_TISSUBMITSUCCESS = 'SET_TISSUBMITSUCCESS';
export const SET_TMINFOSHOW = 'SET_TMINFOSHOW';
export const SET_TSUBMITERRMSG = 'SET_TSUBMITERRMSG';
export const SET_TFINALABLEDATES = 'SET_TFINALABLEDATES';
// 自建THSR
export const SET_TOPENNVBRSLB = 'SET_TOPENNVBRSLB';
export const SET_TALLSESSIONS = 'SET_TALLSESSIONS';
export const SET_TDISABLEDSESSIONS = 'SET_TDISABLEDSESSIONS';
export const SET_TPICKSESSION = 'SET_TPICKSESSION';
export const SET_TDISABLEDDATEBYSESSION = 'SET_TDISABLEDDATEBYSESSION';
export const SET_TMINDATE = 'SET_TMINDATE';
export const SET_TNULLDATE = 'SET_TNULLDATE';
export const SET_TDISABLEDDATE = 'SET_TDISABLEDDATE';
export const SET_TSOLDOUTDATE = 'SET_TSOLDOUTDATE';
export const SET_TETITEMDATA = 'SET_TETITEMDATA';
// export const SET_THASCALENDAR = 'SET_THASCALENDAR';
// export const SET_THASSESSION = 'SET_THASSESSION';
// export const SET_TISLOADINGDATA = 'SET_TISLOADINGDATA';
/*
// GDSTHSR
export const SET_TGRESTORE = 'SET_TGRESTORE';
export const SET_TGRESET = 'SET_TGRESET';
export const SET_TGCALENDAR = 'SET_TGCALENDAR';
export const SET_TGTICKECTNUM = 'SET_TGTICKECTNUM';
export const SET_TGSESSION = 'SET_TGSESSION';
export const SET_TGSESSIONPICKED = 'SET_TGSESSIONPICKED';
export const SET_TGTOTALAMOUNT = 'SET_TGTOTALAMOUNT';
export const SET_TGDETAIL = 'SET_TGDETAIL';
export const SET_TGTEMPCALENDARDATA = 'SET_TGTEMPCALENDARDATA';
export const SET_ISTGDSDETAILLOADING = 'SET_ISTGDSDETAILLOADING';
export const SET_TGDDETAILFETCHFAIL = 'SET_TGDDETAILFETCHFAIL';
export const SET_ISTGDSSESSIONLOADING = 'SET_ISTGDSSESSIONLOADING';
export const SET_TGDSSESSIONFETCHFAIL = 'SET_TGDSSESSIONFETCHFAIL';
export const SET_TGNOWLIST = 'SET_TGNOWLIST';
export const SET_TGNOWLISTDATA = 'SET_TGNOWLISTDATA';
export const SET_TGMINFOSHOW = 'SET_TGMINFOSHOW';
export const SET_TGCALENDARERR = 'SET_TGCALENDARERR';
export const SET_TGSESSIONERR = 'SET_TGSESSIONERR';
export const SET_TGTICKETErr = 'SET_TGTICKETErr';
export const SET_TGSCROLLTO = 'SET_TGSCROLLTO';
export const SET_TGSUBMITWATCHER = 'SET_TGSUBMITWATCHER';
export const SET_ISTGSUBMITSUCCESS = 'SET_ISTGSUBMITSUCCESS';
export const SET_TGFINALABLEDATES = 'SET_TGFINALABLEDATES';
export const SET_TGSUBMITERRMSG = 'SET_TGSUBMITERRMSG';
*/
